import { Modal } from '~components/Modals/Base';
import { Text } from '~components/Typography';
import { useTranslations } from '~i18n/hooks';
import BlockCircleIcon from '~public/assets/icons/block-circle.svg';
import CloseIcon from '~public/assets/icons/close.svg';
import { generationApiErrorCodes } from '~services/api/generation';
import { ButtonPrimary } from '~shared/ui/atoms/Buttons/ButtonPrimary';
import { PortableText } from '~shared/ui/integrations/Sanity';

import { CloseButton, StyledErrorModalWrapper } from './styles';

export const ErrorModal = ({
	open,
	errorCode,
	onClose,
	onAction,
}: {
	open: boolean;
	errorCode: string;
	onClose: () => void;
	onAction: () => void;
}) => {
	const t = useTranslations('BotWizard');
	const isDataError =
		errorCode === generationApiErrorCodes.invalidData ||
		errorCode === generationApiErrorCodes.unsafeAvatar;
	return (
		<Modal onClose={onClose} open={open}>
			<StyledErrorModalWrapper>
				<CloseButton onClick={onClose} leftIcon={<CloseIcon />} />
				<BlockCircleIcon />
				<Text size="L" underline={true}>
					<PortableText
						value={
							isDataError
								? t.raw('errorPopupTextDataV2')
								: t.raw('errorPopupText')
						}
					/>
				</Text>
				<ButtonPrimary
					onClick={() => (isDataError ? onClose() : onAction())}
					size="M"
				>
					{isDataError
						? errorCode === generationApiErrorCodes.invalidData
							? t('errorPopupButtonTextDataName')
							: t('errorPopupButtonTextDataPrompt')
						: t('errorPopupButtonText')}
				</ButtonPrimary>
			</StyledErrorModalWrapper>
		</Modal>
	);
};
